(function() {
     'use strict';

     /**
     *@ngdoc service
     * @memberof app
     *@name DataService
     *@param {service} $http
     *@description
     *Servicio que pertenece a la api de Master
     */
     angular
        .module('app')
        .factory('DataService', ['$http',function ($http){
    	
    	var master = {};
    	
		/**
        * @ngdoc method
        * @name getDataProtectionAcceptance
        * @memberof masterService
        * @description
        * This method will return the list of users
         */
        master.getData = function (name_test,value_test,country,pet_sex,pet_age,date,city){
            var url= '/ajax/analysis';
             return $http({
                method  : 'GET',
                url     : url,
                params :{
                    name_test:name_test,
                    value_test:value_test,
                    country:country,
                    pet_sex:pet_sex,
                    pet_age:pet_age,
                    date:date,
                    city:city
                }                

            })
                .then(success)
                .catch(error);
            
            function success(data){  
                console.log(data);
                return data.data;
            }

            function error(data){
                console.log(data);
                return false;
            }
        }

        master.setCookie = function (){
            var url= '/ajax/setcookies';
             return $http({
                method  : 'POST',
                url     : url,
                params :{
                    
                }                

            })
                .then(success)
                .catch(error);
            
            function success(data){  
                console.log(data);
                return data.data;
            }

            function error(data){
                console.log(data);
                return false;
            }
        }

        return master;

   	
   	}]);



})();